import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Offering } from './types'

export const CREATE_OFFERING: TypedDocumentNode<
  { createOffering: Offering },
  {
    client_id: string
    application_id: string
    title: string
    description?: string | null
    text_to_copy?: string | null
    image?: string | null
    observations?: string | null
  }
> = gql`
  mutation CreateOffering(
    $client_id: ID!
    $application_id: ID!
    $title: String!
    $description: String
    $text_to_copy: String
    $image: String
    $observations: String
  ) {
    createOffering(
      client_id: $client_id
      application_id: $application_id
      title: $title
      description: $description
      text_to_copy: $text_to_copy
      image: $image
      observations: $observations
    ) {
      id client_id application_id title description text_to_copy image image_low_res observations created_at updated_at
    }
  }
`

export const UPDATE_OFFERING: TypedDocumentNode<
  { updateOffering: Offering },
  {
    id: string
    title?: string
    description?: string | null
    text_to_copy?: string | null
    image?: string | null
    observations?: string | null
  }
> = gql`
  mutation UpdateOffering(
    $id: ID!
    $title: String
    $description: String
    $text_to_copy: String
    $image: String
    $observations: String
  ) {
    updateOffering(
      id: $id
      title: $title
      description: $description
      text_to_copy: $text_to_copy
      image: $image
      observations: $observations
    ) {
      id client_id application_id title description text_to_copy image image_low_res observations created_at updated_at
    }
  }
`

export const DELETE_OFFERING: TypedDocumentNode<{ deleteOffering: boolean }, { id: string }> = gql`
  mutation DeleteOffering($id: ID!) {
    deleteOffering(id: $id)
  }
`
